import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { selectPage, fetchPageStikisAsync } from './pagesSlice'
import { setLastPageId } from '../user/userSlice'

import TopMenu from '../../../components/TopMenu'

export default function Page() {
  const dispatch = useDispatch()
  const { id } = useParams()
  const parsedPageId = Number(id)
  const pageId = Number.isFinite(parsedPageId) ? parsedPageId : null
  const page = useSelector(selectPage(pageId))

  useEffect(() => {
    if (page?.title) {
      document.title = page.title
    }
  }, [page?.title])

  // Only my own pages count, as on the server (`User#last_page_accessed`).
  useEffect(() => {
    if (pageId && page?.is_mine) {
      dispatch(setLastPageId(pageId))
    }
  }, [pageId, page?.is_mine, dispatch])

  // /pages.json (the page list) carries no stiki content any more -- this
  // page's own stikis arrive from GET /pages/:id.json, the first time it's
  // actually opened (fetchPageStikisAsync is a no-op on a repeat visit).
  useEffect(() => {
    if (pageId) {
      dispatch(fetchPageStikisAsync(pageId))
    }
  }, [pageId, dispatch])

  return (
    <React.Fragment>
      <TopMenu pageId={pageId} />
    </React.Fragment>
  )
}
